import React, {Component} from 'react';
import _ from 'lodash';

import {brandColor, disabledColor} from 'app/theme';

import I18n from 'app/common/i18n';

import NextIcon from 'app/assets/next-white.svg';

import SkillFilter from './SkillFilter';
import {Button} from 'dk-ui-lib';

export default class FilerSection extends Component {

	renderTitle() {
		return (
			<div className='white bold h3'>{I18n.t('candidates.skill_criteria')}</div>
		);
	}

	handleSearch() {
		this.props.fetchCandidates();
	}

	render() {
		let {filter, assessments, updateFilter} = this.props;
		return (
			<div className='clearfix'>
				<div className='flex items-center mt2 ml2 p3' style={{backgroundColor: 'rgba(0,0,0,0.1)'}}>
					<SkillFilter filter={filter} assessments={assessments} updateFilter={updateFilter}/>
					<div className='ml3'>
	          <Button
	            type='primary'
	            buttonStyle={{padding: '0.75rem'}}
	            labelStyle={{fontSize: '0.9rem'}}
	            icon={<NextIcon className='svg-icon svg-large-small' />}
	            disabled={_.isEmpty(filter.skills)}
	            label={I18n.t('buttons.search')}
	            onClick={() => this.handleSearch()} />
	        </div>
        </div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/candidates/FilterSection.js